import React, { useEffect, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";


// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

const SidebarContent = props => {
  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title" style={{color:"#fff"}}>{props.t("Menu")} </li>
            <li className="menuitem">
              <Link to="/dashboard">
              <i className="bx bxs-home" style={{color:"#fff"}}></i>
                <span className="menuitem">{props.t("Dashboard")}</span>
              </Link>
             
            </li>

          

            <li >
              <Link to="/get-cover" >
   
              <i className="bxr bx-pen" style={{color:"#fff"}}></i>
                <span className="menuitem">{props.t("Get Cover")}</span>
              </Link>
            </li>
              <li >
              <Link to="/bulk-processing" >
   
              <i className="bxr bx-pen" style={{color:"#fff"}}></i>
                <span className="menuitem">{props.t("Bulk Processing")}</span>
              </Link>
            </li>

              {/* <li >
              <Link to="/pending-proposals" >
   
              <i className="bxr bx-pen" style={{color:"#fff"}}></i>
                <span className="menuitem">{props.t("Pending Proposals")}</span>
              </Link>
            </li> */}


            <li>
              <Link to="/active-policies" >
              <i className="bx bxs-car" style={{color:"#fff"}}></i>
                <span className="menuitem">{props.t("Active Policies")}</span>
              </Link>
            </li>
            
            <li>
              <Link to="/extensions" >
              <i className="bx bxs-circle" style={{color:"#fff"}}></i>
                <span className="menuitem">{props.t("Extensions")}</span>
              </Link>
            </li>
             <li>
              <Link to="/notes" >
              <i className="bx bxs-file" style={{color:"#fff"}}></i>
                <span className="menuitem">{props.t("Notes")}</span>
              </Link>
            </li>
         

            <li>
              <Link to="/dashboard" className="has-arrow">
              <i className="bx bxs-detail" style={{color:"#fff"}}></i>
                <span className="menuitem">{props.t("Renewals Management")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link className="menuitem" to="/daashboard">{props.t("")}</Link>
                </li>
                <li className="menuitem">
                  <Link to="/renewals" className="menuitem">
                    {props.t("Upcoming Renewals")}
                  </Link>
                </li>
                <li className="menuitem">
                  <Link to="/expired" className="menuitem">{props.t("Expired")}</Link>
               </li>
              </ul>
            </li>
            {/* <li>
              <Link to="/clients" >
              <i className="bx bxs-contact" style={{color:"#fff"}}></i>
                <span className="menuitem">{props.t("Clients")}</span>
              </Link>
            </li> */}
            <li>
              <Link to="/documents" >
              <i className="bx bxs-file" style={{color:"#fff"}}></i>
                <span className="menuitem">{props.t("Documents")}</span>
              </Link>
            </li>
             <li>
              <Link to="/certificates" >
              <i className="bx bxs-file" style={{color:"#fff"}}></i>
                <span className="menuitem">{props.t("Generated Certificates")}</span>
              </Link>
            </li>
                         <li>
              <Link to="/failed-certificates" >
              <i className="bx bxs-file" style={{color:"#fff"}}></i>
                <span className="menuitem">{props.t("Failed Certificates")}</span>
              </Link>
            </li>






            <li>
              <Link to="/claims" >
              <i className="bx bxs-alarm" style={{color:"#fff"}}></i>
                <span className="menuitem">{props.t("Claims")}</span>
              </Link>
            </li>
            <li>
              <Link to="/dashboard" className="has-arrow">
              <i className="bx bxs-report" style={{color:"#fff"}}></i>
                <span className="menuitem">{props.t("Reports")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link className="menuitem" to="/daashboard">{props.t("")}</Link>
                </li>
                <li className="menuitem">
                  <Link to="/commissions" className="menuitem">
                    {props.t("Commission statement")}
                  </Link>
                </li>
                <li className="menuitem">
                  <Link to="/commission-utilization" className="menuitem">
                    {props.t("Commission utilization")}
                  </Link>
                </li>
                <li className="menuitem">
                  <Link to="/production" className="menuitem">{props.t("Production Report")}</Link>
               </li>
              </ul>
            </li>
             <li>
              <Link to="/wallet" >
              <i className="bx bxs-box" style={{color:"#fff"}}></i>
                <span className="menuitem">{props.t("Wallet")}</span>
              </Link>
            </li>
            

           
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
